module.exports = __webpack_public_path__ + "img/chevron-selector-vertical.f8d0a066.svg";